import { IRoute } from '../types/route';

const protectedRoutes: IRoute[] = [
  // Example: { path: '/admin', element: <AdminPage />, requiredRole: 'admin' },
];

export default protectedRoutes;
